import * as cartConstants from './cartConstants';


export const onCartLoaded = cart => {

    return {
        payload: cart,
        type: cartConstants.ACTION_CART_LOADED
    };
};


export const onCartsLoaded = carts => {

    return {
        payload: carts,
        type: cartConstants.ACTION_CARTS_LOADED
    };
};


export const onCartsLoading = () => {

    return {
        payload: null,
        type: cartConstants.ACTION_CARTS_LOADING
    };
};


export const onCartHeaderUpdated = (cartId, cartHeader) => {

    return {
        payload: {
            cartId,
            cartHeader
        },
        type: cartConstants.ACTION_CART_HEADER_UPDATED
    };
};


export const onCartItemsRemoved = (cartId, cartItemIds) => {

    return {
        payload: {
            cartId,
            cartItemIds
        },
        type: cartConstants.ACTION_CART_ITEMS_REMOVED
    };
};


export const onCartSubmitted = (submittedCartId, newActiveCart) => {

    return {
        payload: {
            newActiveCart,
            submittedCartId
        },
        type: cartConstants.ACTION_CART_SUBMITTED
    };
};
